import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TheCycleverseTheme } from "src/theme";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  errorMessage: {
    fontSize: "16px",
    color: theme.calculatorOrangeBoldColor,
    textAlign: "center",
    width: "75%",
    margin: "auto",
    marginTop: "10px",
    "@media (max-width: 488px)": {
      width: "100%",
    },
  },
}));

export const ErrorMessage: FC<{ message: string; className?: string }> = ({ message, className }) => {
  const classes = useStyles();
  return (
    <p id="error" className={className ? className : classes.errorMessage}>
      {message}
    </p>
  );
};
